import AspectMenu from "@/components/search/AspectMenu";
import ShareIcon from "@mui/icons-material/Share";
import { ReactNode } from "react";
import { AdShareModel, ShareList } from "./ShareList";
import { CreateAnalyticEvent } from "@/actions/details/CreateAnalyticEvent";

export function ShareMenu({
  ad,
  target,
}: {
  ad: AdShareModel;
  target: ReactNode;
}) {
  return (
    <AspectMenu
      label="Share"
      icon={<ShareIcon />}
      target={target}
      body={() => <ShareList ad={ad} />}
      onOpen={() => {
        CreateAnalyticEvent({
          event: {
            adIds: [ad.id],
            eventType: "AD#ENGAGEMENT#SHARE#OPEN",
          },
        });
      }}
    />
  );
}
